import React from "react";
import Combobox from "Components/Combobox";
import WayPoints from "Components/Waypoints";

interface Props {
  instructions: string[];
  combinedStops: { title: string; realLat: number; realLng: number }[];
  setStartId: (id: number) => void;
  setEndId: (id: number) => void;
}

const ADADirections = (props: Props) => {
  const { instructions, combinedStops, setStartId, setEndId } = props;
  const options = combinedStops.map((stop: any) => {
    return {
      name: stop.title,
      id: stop.id,
    };
  });
  return (
    <>
      <Combobox
        placeHolder="Choose Start Location"
        label="Choose Start Location"
        options={options}
        onSelectionChange={setStartId}
      />
      <div style={{ height: "25px" }} />
      <Combobox
        placeHolder="Choose End Location"
        label="Choose End Location"
        options={options}
        onSelectionChange={setEndId}
      />
      <WayPoints steps={instructions} showTitle />
    </>
  );
};

export { ADADirections };
try {
    // @ts-ignore
    ADADirections.displayName = "ADADirections";
    // @ts-ignore
    ADADirections.__docgenInfo = { "description": "", "displayName": "ADADirections", "props": { "instructions": { "defaultValue": null, "description": "", "name": "instructions", "required": true, "type": { "name": "string[]" } }, "combinedStops": { "defaultValue": null, "description": "", "name": "combinedStops", "required": true, "type": { "name": "{ title: string; realLat: number; realLng: number; }[]" } }, "setStartId": { "defaultValue": null, "description": "", "name": "setStartId", "required": true, "type": { "name": "(id: number) => void" } }, "setEndId": { "defaultValue": null, "description": "", "name": "setEndId", "required": true, "type": { "name": "(id: number) => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/ADADirections/ADADirections.tsx#ADADirections"] = { docgenInfo: ADADirections.__docgenInfo, name: "ADADirections", path: "src/shared/components/ADADirections/ADADirections.tsx#ADADirections" };
}
catch (__react_docgen_typescript_loader_error) { }